/**
 * ImageLightbox (KAN-864)
 *
 * A picture shown large in a dialog, limited to the viewport. Closes by Esc,
 * the "Закрыть" button or a click on the backdrop; a click on the picture
 * itself keeps it open. React events bubble through portals to the React
 * parent of the dialog, so every click inside (content and backdrop) is
 * stopped here: the row or card the opener sits in never sees it.
 */
import type { MouseEvent } from 'react'
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'

export interface ImageLightboxProps {
  src: string
  open: boolean
  onOpenChange: (open: boolean) => void
  /** Accessible title of the dialog (screen readers only). */
  title: string
  imageTestId?: string
  backdropTestId?: string
}

function stop(event: MouseEvent) {
  event.stopPropagation()
}

export function ImageLightbox({
  src,
  open,
  onOpenChange,
  title,
  imageTestId,
  backdropTestId,
}: ImageLightboxProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        aria-describedby={undefined}
        onClick={stop}
        overlayProps={{ onClick: stop, 'data-testid': backdropTestId }}
        className="w-auto max-w-[95vw] border-0 bg-transparent p-0 shadow-none sm:rounded-lg [&>button]:bg-white/90 [&>button]:p-1 [&>button]:opacity-90"
      >
        <DialogTitle className="sr-only">{title}</DialogTitle>
        <img
          src={src}
          alt={title}
          data-testid={imageTestId}
          className="max-h-[85vh] max-w-[90vw] rounded-lg object-contain"
        />
      </DialogContent>
    </Dialog>
  )
}
